export const eventKeys = {
  UNLOCK_AUDIO: 'unlock-audio',
  MIC_ON: 'mic-on',
  SS_SET_CREDIT: 'ss-set-credit',
  MCS_SAVE: 'mcs-save',
  SCREEN_SHRINK: 'screen-shrink',
};
